import { EQuizEvents, dispatchCustomEvent } from '@portals/quiz-trigger/lib/build/es';

export enum EQuizID {
    CampaignActionQuiz = 'dd7a0081-3f75-4100-8f52-3c7e9d6c9dff',
    Timeout20SecQuiz = '7793ffba-7ca1-45cc-a94b-979daa276f4d'
}

export const TIMEOUT_20_SEC_QUIZ = 20000;

export const openQuiz = (quizId: EQuizID) => {
    dispatchCustomEvent({
        eventName: EQuizEvents.OPEN_MODAL,
        data     : { quizId }
    });
};
